/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSavingsV2Status} from '../api'

 export const useQueryGetSavingsV2Status = createReactQueryHook('getSavingsV2Status', getSavingsV2Status)
